export function getInitData(): string {
  const tg = window?.Telegram?.WebApp;
  if (process.env.NODE_ENV === 'development') {
    // return 'd0ce709e-3361-4fcc-9c97-53d54a2e74f9';
    // return 'user=%7B%22id%22%3A353357144%2C%22first_name%22%3A%22Mocked%22%2C%22last_name%22%3A%22User%22%2C%22username%22%3A%22mock_user%22%7D&chat_instance=-999001122&auth_date=1720851100&hash=ec3f3a0b2c7e9b01e9fd60b8f55b88aeccab0b8023b24bfc8e514e2c3ac5a7d4';
  }

  if (tg?.initData) {
    return tg.initData;
  }
  throw new Error('initData отсутствует');
}
